'use client';

import { captureException } from '@sentry/nextjs';
import Link from 'next/link';

import { useEffect } from 'react';

// Error components must be Client Components
export default function ErrorPage({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    captureException(error);
  }, [error]);

  return (
    <div className='flex h-screen w-screen flex-col items-center justify-center bg-black pb-20 text-colorFg18'>
      <h2 className='mb-16 rounded-lg border-8 border-red-600 px-8 py-6 font-bold text-5xl text-red-600'>Error !</h2>
      <h4 className='w-[50vw] text-xl'>{error.message}</h4>
      <div className='mt-16 flex gap-4'>
        <button
          className='rounded-[7px] bg-primaryBg px-[30px] text-[17px] text-colorFg12 leading-[48px] hover:underline'
          onClick={
            // Attempt to recover by trying to re-render the segment
            () => reset()
          }
        >
          RESET
        </button>
        <Link
          prefetch={false}
          href='/'
          className='rounded-[7px] bg-primaryBg px-[30px] text-[17px] text-colorFg12 leading-[48px] hover:underline'
        >
          메인으로
        </Link>
      </div>
    </div>
  );
}
